import { Injectable } from "@angular/core";
import { App } from "@capacitor/app";
import { VersionDto } from "../dtos/version.dto";
import { DeviceHelper } from "../helpers/device.helper";

@Injectable({
    providedIn: "root",
})
export class AppVersionService {
    constructor(public deviceHelper: DeviceHelper) {
    }

    public async getAppVersion(): Promise<VersionDto> {
        if (this.deviceHelper.isRunningOnDevice()) {
            return new VersionDto(0, (await App.getInfo()).version);
        } else {
            return new VersionDto(0, "99"); // For browser
        }
    }
}
